// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResultRow-cls1___03358e1b1136ab6b9a4","cls2":"AutoCompleteResultRow-cls2___32b64ce9f49d1681032 AutoCompleteResultRow-cls1___03358e1b1136ab6b9a4"};